export default __webpack_public_path__ + "9d230c2d58c26422b6fc2a8738656f99.otf";